import {syncLandingAnalyticsConsent} from "upsell/offerEventBeacon";
import {useEffect} from "react";
import {getConsent, subscribeConsent} from "consent/consentStore";
import {syncAnalyticsWithConsent} from "./analytics";

/**
 * Keeps Google tagging in step with the consent store for the whole session (ui#256).
 *
 * Mounted ONCE, high in the tree and above anything that unmounts. The cookie banner cannot own this: it
 * unmounts the instant consent is decided, so a later withdrawal from the settings dialog would have nothing
 * listening — the tag would keep collecting until the next reload, which is exactly the "opting out takes
 * effect next visit" behaviour this ticket removes.
 *
 * A thin adapter by mandate: it holds no rules, it only relays store changes to the domain.
 */
export function useAnalyticsConsent(): void {
	useEffect(() => {
		// Returning visitor: apply whatever was already decided, then follow every later change.
		void syncAnalyticsWithConsent();
		const retryErasure = () => { void syncLandingAnalyticsConsent(getConsent()); };
		retryErasure();
		window.addEventListener("online", retryErasure);
		const unsubscribe = subscribeConsent((consent) => {
			void syncAnalyticsWithConsent(consent);
			void syncLandingAnalyticsConsent(consent);
		});
		return () => {
			unsubscribe();
			window.removeEventListener("online", retryErasure);
		};
	}, []);
}
